var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0546875,
    y: 0.771484,
    width: 43.3324,
    height: 43.3324,
    rx: 21.6662,
    fill: "#FF9154"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4534 16.872C36.4534 17.3778 36.2759 17.8077 35.9211 18.1618L22.1576 31.8939L19.5722 34.4735C19.2173 34.8275 18.7864 35.0045 18.2795 35.0045C17.7725 35.0045 17.3416 34.8275 16.9868 34.4735L14.4013 31.8939L7.51959 25.0279C7.16473 24.6738 6.9873 24.2439 6.9873 23.7381C6.9873 23.2323 7.16473 22.8024 7.51959 22.4484L10.105 19.8688C10.4599 19.5148 10.8908 19.3378 11.3977 19.3378C11.9046 19.3378 12.3356 19.5148 12.6904 19.8688L18.2795 25.4641L30.7502 13.0028C31.1051 12.6487 31.536 12.4717 32.043 12.4717C32.5499 12.4717 32.9808 12.6487 33.3357 13.0028L35.9211 15.5823C36.2759 15.9363 36.4534 16.3662 36.4534 16.872Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a81a8332b1c90ff7d27e714344200d43.svg";
export { ForwardRef as ReactComponent };